import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, DropdownV2, TextArea } from '@bridebook/ui';
import { RsvpAnswerType } from '@bridebook/web/lib/rsvp/constants/events';
import { RsvpQuestionFormValues } from '@bridebook/web/lib/rsvp/types';
import { useTranslation } from 'next-i18next';
import { useGetPlaceholderAnswerTypeOptions } from '@bridebook/web/lib/rsvp/hooks/use-get-placeholder-answer-type-options';

interface IProps {
  control: Control<RsvpQuestionFormValues>;
  error?: string;
}

const splitAndTrimViableAnswers = (ans: string) =>
  ans
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter((s) => s !== '');

export const AnswerTypeField: FC<IProps> = ({ control, error }) => {
  const { t } = useTranslation('weddingWebsite');
  const listPlaceholder = t('rsvp.form.list.options.placeholder').split(', ').join('\n');
  const placeholderAnswerTypeOptions = useGetPlaceholderAnswerTypeOptions();
  return (
    <Box gap={2}>
      <Controller
        name="type"
        control={control}
        render={({ field: typeField }) => (
          <>
            <DropdownV2
              fullWidth
              placeholder={t('rsvp.form.answer.placeholder')}
              required
              options={placeholderAnswerTypeOptions}
              selected={typeField.value}
              onSelect={(option) => typeField.onChange(option.value)}
            />
            {typeField.value === RsvpAnswerType.List && (
              <>
                <div>
                  <Controller
                    name="options"
                    control={control}
                    render={({ field: answerField }) => (
                      <TextArea
                        label={t('rsvp.form.list.options.label')}
                        required
                        placeholder={listPlaceholder}
                        value={answerField.value?.join('\n') || ''}
                        onChange={(e) => answerField.onChange(splitAndTrimViableAnswers(e))}
                        error={error}
                        withAdjustableHeight
                      />
                    )}
                  />
                </div>
                <p className="text-xs leading-[150%] text-space-75">
                  {t('rsvp.form.list.newLineHint')}
                </p>
              </>
            )}
          </>
        )}
      />
    </Box>
  );
};
